import { Divider, Grid, List } from "@mui/material";
import clsx from "clsx";
//#endregion
//#region components
import NavigationListItem from "./navigationListItem";
import { WelcomeGuideTooltip } from "components/welcomeGuide";
//#region types
import { NavigationListContentProps, NavigationListProps, NavListItemProps } from "models/propTypes/navListPropTypes";
import React from "react";
//#endregion
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { TranslationKeys } from "translations";
import { CommonConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";

const NavigationList: React.FC<NavigationListContentProps & NavigationListProps> = (props) => {
  const shownHelps = useSelector((state: AppState) =>
    state.auth.profileToggles.shownHelps?.includes(CommonConstants.WelcomeGuideId)
  );
  const shownIntroductions = useSelector((state: AppState) =>
    state.auth.profileToggles.shownIntroductions?.includes(CommonConstants.WelcomeGuideId)
  );

  const getNavList = (navListItems: NavListItemProps[], className?: string) => {
    return (
      <List className={clsx(cssExports.navList, className)}>
        {navListItems.map((item) =>
          !item.hidden ? (
            <NavigationListItem key={item.id} {...item} collapsed={props.collapsed} />
          ) : (
            <React.Fragment key={item.id}></React.Fragment>
          )
        )}
      </List>
    );
  };

  return (
    <>
      <Grid item className={cssExports.navListsContainer}>
        {shownIntroductions && !shownHelps ? (
          <WelcomeGuideTooltip
            open={true}
            placement="right-start"
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NavigationHelpText)}
            content={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NavigationContentHelpText)}
          >
            {getNavList(props.topNavListItems)}
          </WelcomeGuideTooltip>
        ) : (
          <>{getNavList(props.topNavListItems)}</>
        )}
      </Grid>
      <Grid item className={cssExports.navListsBottomContainer}>
        <Divider className={cssExports.navDivider}></Divider>
        <Grid item container className={cssExports.navListsBottomInnerContainer}>
          {getNavList(props.bottomNavListItems)}
        </Grid>
      </Grid>
    </>
  );
};

export default NavigationList;
